// Actions

export const MANAGE_ACTION = 'manage'

export const CREATE_ACTION = 'create'

export const UPDATE_ACTION = 'update'

export const READ_ACTION = 'read'

export const DELETE_ACTION = 'delete'

// API resources

export const CONTRACT_RESOURCE = 'contract'

export const PIX_INSTALLMENT_PLAN_RESOURCE = 'pix_installment_plan'

export const FINANCIAL_SOLUTION_RESOURCE = 'financial_solution'

export const PARTNER_COMPANY_RESOURCE = 'partner_company'

export const PRODUCT_RESOURCE = 'product'

export const INTERVIEW_RESOURCE = 'interview'

export const INTERVIEW_PROPOSAL_RESOURCE = 'interview_proposal'

export const CONSULTANT_RESOURCE = 'consultant'

export const REPORT_RESOURCE = 'report'

export const LEAD_RESOURCE = 'lead'

export const ANNOUNCEMENT_RESOURCE = 'announcement'

export const WHATS_NEW_RESOURCE = 'whats_new'

export const CUSTOMER_RESOURCE = 'customer'

export const WITHDRAWAL_RESOURCE = 'withdrawal'

export const FINANCIAL_ADJUSTMENTS = 'financial_adjustment'

export const FINANCIAL_BATCH = 'financial_batch'

export const FINANCIAL_MANAGMENT = 'financial_management'

export const PAYMENT_IMPORT = 'payment_import'

export const NPS_SURVEY = 'nps_survey'

export const CAMPAIGN = 'campaign'

export const BUSINESS_UNIT = 'business_unit'

export const DASHBOARD_BANNER = 'dashboard_banner'

export const SUPPORT_TICKET = 'support_tickets'

export const COMMISSION_MANAGEMENT = 'commission_management'

export const EXPENSE = 'expense'

export const PROFILE = 'profile'

export const LEAD_CUSTOMER = 'lead_customer'

export const LEAD_PN = 'lead_pn'

export const APPOINTMENT = 'appointment'

export const FRANCHISE = 'physical_franchise'

export const KPI = 'kpi'

export const COPILOT_AUDIT = 'copilot_audit'

export const COMMISSION = 'commission'

export const CONTRACT_ADMINISTRATION = 'contract_administration'

export const OPPORTUNITY_MAP = 'opportunity_map'

export const PERFORMANCE_EVOLUTION = 'performance_evolution'

export const PENDING_INTERVIEWS = 'pending_interviews'

export const BUSINESS_SCHOOL = 'business_school'

export const BUSINESS_SCHOOL_PROGRESS = 'business_school_progress'

export const BUSINESS_SCHOOL_PREPOSTO = 'business_school_preposto'

export const BUSINESS_SCHOOL_FRANQUEADO = 'business_school_franqueado'

export const BUSINESS_SCHOOL_EXPANSAO = 'business_school_expansao'

export const BUSINESS_SCHOOL_CLIENTE = 'business_school_cliente'

export const NPS_SURVEY_FRANCHISE = 'nps_survey_franchise'

export const TRANSFER_CUSTOMER = 'transfer_customer'

export const TRANSFER_CONSULTANT = 'transfer_consultant'

export const TRANSFER_LEAD = 'transfer_lead'

export const TRANSFER_CONSULTANT_LEAD = 'transfer_consultant_lead'

export const DIGITAL_FRANCHISE_READ = 'digital_franchise_read'

export const SUBSCRIPTIONS_STATISTICS = 'subscriptions_statics'

export const FEEDZ = 'feedz'

export const SOLIDES = 'solides'

export const USEFUL_LINKS = 'useful_links'

export const USEFUL_LINKS_FRANCHISE = 'useful_links_franchise'

export const USEFUL_LINKS_PREPOSTO = 'useful_links_preposto'

export const DIGITAL_FRANCHISE = 'digital_franchise'

export const OVERDUE_SIGNATURE_REPORT = 'overdue_signature_report'

export const INACTIVE_PN_CONTRACTS_REPORT = 'inactive_pn_contracts_report'

export const INACTIVE_PN_CUSTOMERS_REPORT = 'inactive_pn_customers_report'

export const CONSULTANT_TERMINATION_REPORT = 'consultant_termination_report'

export const SALESOPS_REPORT = 'salesops_report'

export const CONTRACTS_AND_CUSTOMERS_REPORT = 'contracts_and_customers_report'

export const EPS_SUBSCRIPTIONS_AND_SOLUTIONS_REPORT = 'eps_subscriptions_and_solutions_report'

export const CUSTOMERS_EXPORT_REPORT = 'customers_export_report'

export const INVOICE_BILLING = 'invoice_billing'

export const INVOICING_RANKING = 'invoicing_ranking'

export const SPECIALIST_CONSULTANT_RANKING = 'specialist_consultant_ranking'

export const PILARES_RANKING = 'pilares_ranking'

export const DEPARTMENT_MEMBERS = 'department_members'

export const ORGANIZATION_CHART = 'organization_chart'

export const FUTURO_STORE = 'futuro_store'

export const PEFORMANCE_EVOLUTION = 'performance_evolution'

export const COMMISSIONS_FOCUSNFE_REPORT = 'commissions_focusnfe_report'

export const CAMPAIGN_KPI = 'campaign_kpi'

export const CHANGE_CONSULTANT_ROLE = 'change_consultant_role'
export const APPROVE_CONSULTANT_ROLE = 'approve_consultant_role'

export const CHANGE_PHYSICAL_FRANCHISE = 'change_physical_franchise'

export const RECRUITMENT = 'recruitment'

export const JOB_SAMPLE_DATE = 'job_sample_date'

export const DISCOUNT_COUPON = 'discount_coupon'

export const CONTRACT_CLOSING = 'contract_closing'

export const CONTRACT_CLOSING_EXCEPTION = 'contract_closing_exception'

export const FRANCHISE_MANUAL = 'franchise_manual'

export const SNAPSHOT_CHANGE = 'snapshot_change'

export const SNAPSHOT_APPROVER = 'snapshot_approver'

// API resources menu
export const LEAD_CUSTOMER_MENU = 'lead_customer_menu'

export const CUSTOMER_RESOURCE_MENU = 'customer_resource_menu'

export const APPOINTMENT_MENU = 'appointment_menu'

export const REQUEST_SPECIALIST_MENU = 'request_specialist_menu'

export const CREATE_CONTRACT_RESOURCE_MENU = 'create_contract_resource_menu'

export const MY_CONTRACT_RESOURCE_MENU = 'my_contract_resource_menu'

export const COTACOES_MENU = 'cotacoes_menu'

export const FINANCIAL_SOLUTION_RESOURCE_MENU = 'financial_solution_resource_menu'

export const PARTNER_COMPANY_RESOURCE_MENU = 'partner_company_resource_menu'

export const PRODUCT_RESOURCE_MENU = 'product_resource_menu'

export const NOTIFICATIONS_RESOURCE_MENU = 'notifications_resource_menu'

export const CONTRACT_DELETE_RESOURCE_MENU = 'contract_delete_resource_menu'

export const CONTRACT_CLOSING_RESOURCE_MENU = 'contract_closing_resource_menu'

export const CONTRACT_CLOSING_EXCEPTION_RESOURCE_MENU = 'contract_closing_exception_resource_menu'

export const RANKING_COMPROMISSOS_MENU = 'ranking_compromissos_menu'

export const DNA_RANKING_MENU = 'dna_ranking_menu'

export const MY_COMMISSIONS_MENU = 'my_commissions_menu'

export const PLANEJADORES_SELECTION_MENU = 'planejadores_selection_menu'

export const LEAD_PN_MENU = 'lead_pn_menu'

export const MY_TEAM_MENU = 'my_team_menu'

export const IMPORTER_CONSULTANT_MENU = 'importer_consultant_menu'

export const NPS_STRUCTURE_MENU = 'nps_structure_menu'

export const DASHBOARD = 'dashboard'

export const MOMENTO_X = 'momento_x'

export const APP_MEU_FUTURO = 'app_meu_futuro'

export const PLANO_FINANCEIRO = 'plano_financeiro'

export const PLAN_IMPLEMENTATION_RESOURCE = 'plan_implementation'

export const AI_PRE_INTERVIEW = 'ai_pre_interview'

export const FINANCIAL_ADJUSTMENT_APPROVAL = 'financial_adjustment_approval'

export const EMPLOYEE = 'employee'

export const EMPLOYEE_MENU = 'employee_menu'

export const NETWORKER_MENU = 'networker_menu'

export const REALIZED_OKR = 'realized_okr'

export const PLANNED_OKR = 'planned_okr'

export const CERTIFICATE_MANAGEMENT_MENU = 'consultant_certificate'

// Recurso próprio: no CASL, `manage` em consultant_certificate liberaria qualquer ação nova ali.
export const CERTIFICATE_APPROVAL_RESOURCE = 'consultant_certificate_approval'

export const FUNNEL_FINANCIAL_PLNANNING = 'funnel_financial_plnanning'

export const INVESTMENT_FUNDS_MENU = 'investment_funds_menu'

export const FIXED_INCOME_DAILY_OFFERS_MENU = 'fixed_income_daily_offers_menu'

export const DIGITAL_FRANCHISE_PURCHASE = 'digital_franchise_purchase'

export const COMMISSION_SHAREHOLDER_DNA_EQUITY = 'commission_shareholder_dna_equity'

export const COMMISSION_SHAREHOLDER_DNA_PRESENTATION = 'commission_shareholder_dna_presentation'

export const FINANCIAL_SHAREHOLDER_DNA_EQUITY = 'financial_shareholder_dna_equity'

export const FINANCIAL_SHAREHOLDER_DNA_PRESENTATION = 'financial_shareholder_dna_presentation'

export const DASHBOARD_FTR_INVEST = 'dashboard_ftr_invest'

export const SUBSCRIPTION_REPLACEMENTS_STATICS = 'subscription_replacements_statics'

export const DASHBOARD_CX = 'dashboard_cx'

export const DASHBOARD_FRANQ_FINDER = 'dashboard_franq_finder'

export const EXTEND_CONSULTANT_DEADLINE = 'extend_consultant_deadline'

export const NETWORKER_LEAD_CREATION = 'networker_lead_creation'

export const BI_REPORTS_MENU = 'bi_reports_menu'
export const BI_REPORTS_PN_MENU = 'bi_reports_pn_menu'

// O backend emite `financial_batch_menu:read` para o mesmo conjunto de perfis de
// `financial_batch:read`, mas nenhuma rota da API o exige: quem gatilha menu e rota é
// FINANCIAL_BATCH. Esta constante existe só para manter a ability na lista fixa abaixo.
export const FINANCIAL_BATCH_RESOURCE_MENU = 'financial_batch_menu'

export const FIXED_FINANCIAL_MENU_RESOURCES = [
  FINANCIAL_ADJUSTMENTS,
  FINANCIAL_ADJUSTMENT_APPROVAL,
  FINANCIAL_BATCH,
  // A ability de menu continua sendo emitida pelo backend e aparece no editor de perfis;
  // fora desta lista, quem não administra o Financeiro poderia configurá-la.
  FINANCIAL_BATCH_RESOURCE_MENU,
  FINANCIAL_MANAGMENT,
  COMMISSION_MANAGEMENT,
  EXPENSE,
  PAYMENT_IMPORT,
  DISCOUNT_COUPON,
  INVOICE_BILLING,
  FINANCIAL_SHAREHOLDER_DNA_EQUITY,
  FINANCIAL_SHAREHOLDER_DNA_PRESENTATION,
]

// Chat com clientes do app MeuFuturo (abilities `customer_chat:<action>` do backend-core)
export const CUSTOMER_CHAT_RESOURCE = 'customer_chat'

export const CUSTOMER_CHAT_WRITE_ACTION = 'write'

export const CUSTOMER_CHAT_SUPERVISE_ACTION = 'supervise'

export const CUSTOMER_CHAT_ADMIN_ACTION = 'admin'

// Acesso do cliente ao Meu Futuro App (abilities `meufuturo_app_access:<action>` do
// backend-core, contrato C4): `read` vê o bloco na ficha; `manage` republica o estado.
export const MEUFUTURO_APP_ACCESS_RESOURCE = 'meufuturo_app_access'
